import {REFRESH_REPORTS_DETAIL} from '../actions/reportDetail';
import moment from 'moment';

const initState = {
  reports: {
    ':reportid': {
      data: {
        productId: 22,
        // 不同产品的info对象不同
        info: {
          // 0量如江海，1众醉独醒，... 4滴酒不沾
          rank: 4,
          populate: '0',
          // 结果说明
          resultSummary: '您的酒精代谢能力为强。....',
          result: [
            // 乙醇代谢
            {
              // rs1229984基因型为AA
              genotype: 'AA',
              // 0乙醇代谢能力强，1中，2弱
              rank: 1,
              // 基因图谱图片地址
              picUrl: 'http://xx'
            },
            // 乙醛代谢
            {
              // rs671基因型为AA
              genotype: 'GG',
              // 0乙醛代谢能力强，1中，2弱
              rank: 1,
              // 基因图谱图片地址
              picUrl: 'http://xx'
            }
          ],
          // 检测原理
          principle: '',
          // 小建议
          advise: ''
        }
      },
      lastUpdateTime: moment().subtract(1, 'days')
    }

  }
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_REPORTS_DETAIL: {
      const {reportId, reportData} = action;

      // 从未请求过报告
      if (!state.reports[reportId]) {
        return Object.assign({}, state, {
          reports: Object.assign({}, state.reports, {
            [reportId]: {
              data: reportData,
              lastUpdateTime: moment()
            }
          })
        });
      }

      return Object.assign({}, state, {
        reports: Object.assign({}, state.reports, {
          [reportId]: Object.assign({}, state.reports[reportId], {
            data: reportData,
            lastUpdateTime: moment()
          })
        })
      });
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/reportDetail.js